<template>
  <div class="project-trial-item" @click.stop="() => goToTrialInfo()">
    <div class="trial-upper-info">
      <div class="trial-main-info">
        <div class="trial-title">{{ trial.name }}</div>
        <div class="trial-status-pill" :class="[trial.status]">
          <div class="trial-status-text">
            {{ $t("status_" + trial.status) }}
          </div>
        </div>
      </div>
      <div class="trial-action-info">
        <div class="trial-dates">
            <div class="trial-detail-icon date-icon"></div>
            <div v-if="trial.creationTimestamp"
            >Created: {{ trial.creationTimestamp | formatDate }}</div
            >
            <div v-if="trial.lastRunTimestamp">Last update: {{ trial.lastRunTimestamp | formatDate }}</div
            >
          </div>
        <div class="separator"></div>
        <!--<div class="output-info"
          v-tooltip="{ content: `
            Output: ${trial.requestedOutput.modelling}
          `}"
          >
            {{ $t("output_analysis") }}
        </div>-->
        <div class="action-buttons">
          <trial-action-bar :trial="trial" @duplicate="() => $emit('duplicate')" @download="$emit('download')"></trial-action-bar>
        </div>
      </div>
    </div>
    <div class="trial-lower-info">
      <!--<div class="background"></div>-->
      <div class="trial-config-item trial-participants" v-if="trial.cohortGeneration">
        <div class="trial-detail-icon participants-icon"></div>
        <div class="trial-detail-info">{{trial.cohortGeneration.numberOfSubjects}} subjects ({{this.infoPopulationName}})</div>
        <!-- <div v-else class="trial-detail-info">{{trial.cohortGeneration.originTemplateIds.length}} subjects</div> -->
      </div>
      <div class="trial-config-item trial-config-item-disease" v-if="infoDiseases">
        <div class="trial-info-icon"></div>
        {{infoDiseases}}
      </div>
      <div class="trial-config-item trial-config-item-tratmnet" v-if="infoTreatments">
        <div class="trial-info-icon"></div>
        {{infoTreatments}}
      </div>
      <div class="trial-config-item tokens-info">
        <div class="tokens-icon"></div>
        <div>{{$t('cost')}}: {{trial.runConfig.computeTokens}} {{$t('compute_tokens')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import TrialActionBar from '@/components/trial/TrialActionBar'

export default {
  name: 'ProjectTrialsListItem',
  props: ['trial'],
  components: {TrialActionBar},
  data() {
    return {
      configMap: [
          {
            'label': 'population',
            'key': 'parameters'
          },
          {
            'label': 'disease',
            'key': 'diseases'
          },
          {
            'label': 'treatment',
            'key': 'treatments'
          },
        ]
    }
  },
  computed: {
    infoPopulationName() {
      if(this.trial.cohortGeneration && this.trial.cohortGeneration.population) {
        return this.trial.cohortGeneration.population.parameters[0].value[0]
      }
    },
    infoDiseases (){
      if(this.trial.cohortGeneration && this.trial.cohortGeneration.population && this.trial.cohortGeneration.population.diseases){
        return this.trial.cohortGeneration.population.diseases.map(d => d.name).join(', ')
      }
      return ''
    },
    infoTreatments () {
      if(this.trial.treatments){
        return this.trial.treatments.map(d => d.name).join(', ')
      }
      return ''
    }
  },
  methods: {
    hasConfig(key) {
      // MENTIRA!
      return false // this.trial.cohort.hasOwnProperty(key) && this.trial.cohort[key].length > 0
    },
    configTooltip (configItem) {
      let c = false
      if (this.hasConfig(configItem.key)) {
        c = configItem.label + ' : ' + this.trial.cohort[configItem.key].map(e => e.id ).join(', ')
      }
      return c
    },
    goToTrialInfo () {
      this.$router.push(`/project/${this.trial.projectId}/trial/${this.trial.id}`)
    }
  }

}
</script>

<style lang="stylus" scoped>
.project-trial-item
  background-color: $titan-white
  padding-left: 25px
  padding-right: 25px
  border-radius 2px
  border 1px solid $titan-white

  &:hover
    border 1px solid $heather
    cursor pointer
  &:not(:last-child)
    margin-bottom: 5px

  .trial-upper-info
    align-items: center
    display: flex
    min-height: 55px
    
    border-bottom 1px solid $mystic
    .trial-main-info
      display flex
      align-items center
      .trial-title
        m-font-size(20, 25)
        font-weight: $fw-semi-bold
        margin-right 15px


    .trial-action-info
      align-items: center
      display: flex
      margin-left: auto
      +m-breakpoint(sm md)
        display none
      .trial-dates
        display flex
        align-items: center
        color: rgba($cloud-burst, 0.4)
        m-font-size(14, 20)
        .date-icon
          m-icon("calendar", 25)
      .output-info
        display: none
        margin-right: 10px

      .output-info,
      .trial-params-info
        cursor default
        align-items: center
        background-color: rgba(#fff, 0.7)
        border-radius: 15px
        box-shadow: 0 5px 15px rgba($lynch, 0.25)
        display: flex
        height: 30px
        m-font-size(12, 14)
        padding: 5px 10px

      .action-buttons
        align-items: center
        display: flex

      .contextual-menu
        margin-left: 5px

  .trial-lower-info
    align-items: center
    background-color: $titan-white
    display: flex
    m-font-size(12, 14)
    min-height: 30px
    position: relative
    flex-wrap wrap

    //&:before
    //  background: $lynch
    //  background: linear-gradient(180deg, rgba($lynch, 0.25) 0, rgba($lynch, 0) 100%)
    //  content: ""
    //  height: 100%
    //  left: 0
    //  opacity: 0.5
    //  position: absolute
    //  top: 0
    //  width: 100%

    .trial-config-item
      margin-top 5px
      margin-bottom 5px
      margin-right: 20px
      position: relative
      display flex
      align-items center
      color: rgba($cloud-burst, 0.6)
      .trial-info-icon
        min-width 15px
        m-icon("patient-value-dark", 10)
        margin-right 5px
      .participants-icon
        min-width 15px
        margin-right 5px
        m-icon("participants", 10)
      &.tokens-info
        margin-left auto
        white-space: nowrap
        .tokens-icon
          m-icon("tokens", 18)
          margin-right 5px


    .view-results-link
      margin-left: auto
      position: relative

      > a
        color: $radical-red
        cursor: pointer
        text-decoration: none

        &:hover
          text-decoration: underline

.separator
  background: $mischka
  height: 30px
  margin-left: 20px
  margin-right: 20px
  width: 1px
</style>